export default __webpack_public_path__ + "static/media/sign-in-header-background.e413f0b3.jpg";